// extracted by mini-css-extract-plugin
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--71298";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--90833";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--3325a";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--13db6";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--e4fe0";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--7ff33";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--f0715";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--22973";